export default __webpack_public_path__ + "static/media/989cef07419f26c0055714f8e1183f5d1580383551372.2446964b.webp";